import { TableCell } from '@repo/go-table';
import type { GridRenderCellParams } from '@repo/go-table';
import { useTranslation } from 'react-i18next';

import type { ManualAnomaliesValidationService } from '../services/ManualAnomaliesValidationService';
import type { TManualAnomalyRowData } from '../types';
import { observer } from 'mobx-react-lite';

type Props = {
  params: GridRenderCellParams;
  validationService: ManualAnomaliesValidationService;
};

export const ManualAnomalyCell = observer<Props>(function ManualAnomalyCell({ params, validationService }) {
  const { t } = useTranslation();

  const errors = validationService.errors
    .get(params.id as string)
    ?.[params.field as keyof TManualAnomalyRowData]?.map((error: string) => <p key={error}>{t(error)}</p>);

  return (
    <TableCell
      style={{
        backgroundColor: (!!errors?.length && 'var(--go-table-cell-error-bg-color)') || undefined,
      }}
      message={errors?.length ? errors : undefined}
    >
      {params.formattedValue}
    </TableCell>
  );
});
